import React, { useEffect, useRef, useState } from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import URL from '../../constants/urls'
import { errorMessage } from '../../constants/errorMessage'
import Loader from '../../global/Loader'

const CardConnectTokenizer = (props) => {
  const tokenRef = useRef(null)
  const { setToken, faciltyPaymentDetails, setIframeErrorMessage } = props
  const [isLoading, setIsLoading] = useState(true)

  useEffect(() => {
    const handleMessage = (event) => {
      try {
        let data
        // Handle different data types
        if (typeof event.data === 'string') {
          try {
            data = JSON.parse(event.data)
          } catch (jsonError) {
            // If it's a string but not valid JSON, treat it as a token
            if (event.data && event.data !== '[object Object]') {
              data = { message: event.data }
            } else {
              throw new Error('Invalid data format received')
            }
          }
        } else if (typeof event.data === 'object' && event.data !== null) {
          // Data is already an object
          data = event.data
        } else {
          throw new Error('Unsupported data type received')
        }
        
        if (data && data.message) {
          // Clear any previous error when successful
          
          if (setIframeErrorMessage) {
            setIframeErrorMessage('')
          }
          
          if (tokenRef.current) {
            tokenRef.current.value = data.message
          }
          
          setToken(data)
        } else if (data && data.validationError) {
          // Set error message for validation errors
          if(data.errorMessage === 'Invalid Account Number'){
            data.validationError = errorMessage.invalidCardNumber
          }

          if (setIframeErrorMessage) {
            setIframeErrorMessage(data.validationError)
          }
          throw new Error(data.validationError)
        } else if (data && data.error) {
          // Handle error property
          if (data.errorMessage === 'Invalid Account Number') {
            data.validationError = errorMessage.invalidCardNumber
          }

          if (setIframeErrorMessage) {
            setIframeErrorMessage(data.error)
          }
          throw new Error(data.error)
        }
      } catch (error) {
        // Set error message for any other errors
        if (setIframeErrorMessage) {
          setIframeErrorMessage(error.message || errorMessage.somethingWentWrong)
        }
      }
    }

    window.addEventListener('message', handleMessage)
    return () => window.removeEventListener('message', handleMessage)
  }, [setToken, faciltyPaymentDetails])

  const css = encodeURIComponent(`
      body{
        border: none !important;
        font-family: Rubik !important;
      }
      input, select {
        padding: 12px 16px !important;
        border: 1px solid #ccc !important;
        border-radius: 6px !important;
        margin: 7px 0px !important;
        max-width: 100% !important;
        box-sizing: border-box !important;
        font-size: 12px !important;
      }
      input[name="ccnumfield"]{
        width: 100% !important;
      }
      input::placeholder {
        font-size: 12px !important;
      }
      input:focus, select:focus {
        border: 1px solid #26a8e0 !important;
        outline: none !important;
      }
      label{
        font-size: 0.875em !important;
        font-weight: normal !important;
        color: #212529 !important;
      }
      label[for="ccexpiryfieldyear"] {
        display: inline-block !important;
        width: auto !important;
      }
      #ccexpiryfieldmonth,
      #ccexpiryfieldyear {
        width: 48% !important;
        display: inline-block !important;
        vertical-align: middle !important;
      }
      #cccvvfield{
        width: 100% !important;
      }
      @media (min-width: 401px) and (max-width: 850px) {
        input {
          font-size: 13px !important;
          padding: 12px 16px !important;
        }
        #ccexpiryfieldmonth,
        #ccexpiryfieldyear {
          width: 46% !important;
          font-size: 13px !important;
        }
      }
      @media (max-width: 400px) {
        input {
          font-size: 13px !important;
          padding: 12px 16px !important;
          }
          #ccexpiryfieldmonth,
          #ccexpiryfieldyear {
            width: 44% !important;
            font-size: 13px !important;
        }
    }
`)
  const iframeSrc = `${faciltyPaymentDetails?.fiserv_iframe_url}?${URL?.FISERV_IFRAME_FORMAT_URL}&css=${css}`

  return (
    <form id="tokenform" name="tokenform" className="token-form" style={{ width: '100%'}}>
      <div className="token-container" width="100%" style={{ position: 'relative', minHeight: '250px' }}>
        {isLoading && (
          <div style={{ 
            position: 'absolute', 
            top: 0, 
            left: 0, 
            right: 0, 
            bottom: 0, 
            display: 'flex', 
            alignItems: 'center', 
            justifyContent: 'center',
            backgroundColor: 'rgba(255, 255, 255, 0.9)',
            zIndex: 10
          }}>
            <Loader />
          </div>
        )}
        <iframe
          id="card_number"
          name="card_number"
          src={iframeSrc}
          frameBorder="0"
          scrolling="no"
          title="Secure Card Input"
          className="token-iframe"
          style={{ width: '100%', height: '250px', border: 'none', marginTop: 0 }}
          onLoad={() => setIsLoading(false)}
        ></iframe>
      </div>

      {/* Hidden input for token */}
      <input type="hidden" id="mytoken" name="mytoken" ref={tokenRef} />
    </form>
  )
}

CardConnectTokenizer.propTypes = {
  dispatch: PropTypes.func,
  loader: PropTypes.bool,
  onSubmit: noop,
  isSubmittingForm: PropTypes.bool,
  setToken: PropTypes.func,
  faciltyPaymentDetails: PropTypes.object,
  setIframeErrorMessage: PropTypes.func
}

export default CardConnectTokenizer
